import { Component } from '@angular/core';

import {
    Router,
    RouterLink,
    RouterLinkActive
} from '@angular/router';

import {
    NgIf
} from '@angular/common';


@Component({
    selector: 'app-navbar',

    standalone: true,

    imports: [
        RouterLink,
        RouterLinkActive,
        NgIf
    ],

    templateUrl: './navbar.html',

    styleUrl: './navbar.scss'
})
export class Navbar {

    menuOpen = false;


    constructor(
        private router: Router
    ) {}


    // ============================
    // DOWNLOAD
    // ============================

    testDownload(): void {

        console.log('DOWNLOAD CLICK RADI');

        window.open(
            'https://drive.google.com/file/d/1U1ofbswTDA5GMuUCUmn_Y5TDSUThXR7r/view',
            '_blank'
        );

        this.menuOpen = false;
    }


    // ============================
    // KATALOG
    // ============================

    goToCatalog(event: Event): void {

        event.preventDefault();

        this.menuOpen = false;


        // Ako smo već na Home
        if (this.router.url === '/') {

            this.scrollToCatalog();

            return;
        }


        // Ako smo na drugoj stranici
        this.router.navigate(['/']).then(() => {

            setTimeout(() => {

                this.scrollToCatalog();

            }, 100);

        });

    }


    // ============================
    // SCROLL
    // ============================

    private scrollToCatalog(): void {

        const element =
            document.getElementById('katalog');


        if (element) {

            element.scrollIntoView({

                behavior: 'smooth',

                block: 'start'

            });

        }

    }

}